<script setup>
import { ref } from 'vue';
const props = defineProps(['filters', 'type']);
const model = defineModel();
const maxVisiblyOptions = 6;
const toggleShow = ref(false);
</script>

<template>
	<fieldset class="c-filtergroup">
		<legend>{{ type }}</legend>
		<div
			v-for="(filter, index) in props.filters"
			class="c-filter-option"
			:class="index + 1 >= maxVisiblyOptions && !toggleShow ? 'c-filter-option--hidden' : ''"
		>
			<div class="c-filter-checkbox">
				<input
					type="checkbox"
					:id="filter.id"
					:value="filter"
					v-model="model"
					@focus="index + 1 >= maxVisiblyOptions ? (toggleShow = true) : ''"
				/>
				<label :for="filter.id">{{ filter.name }}</label>
			</div>
			<div class="c-filter-checkbox__count">
				{{ filter.count }}
			</div>
		</div>
		<button
			class="c-filtergroup__toggle"
			v-if="props.filters.length >= maxVisiblyOptions"
			@click="toggleShow = !toggleShow"
		>
			<span v-if="!toggleShow">+ meer</span>
			<span v-else>- minder</span>
		</button>
	</fieldset>
</template>
